import type { CinematicWaypoint } from '../../../renderer/src/cinematic-sequence';

export interface KeyframeTiming {
  transition: 'cut' | 'transition';
  durationSeconds: number | 'interval';
  easing: 'smooth' | 'linear';
}

export function cameraKeyTiming(key: { [K in keyof KeyframeTiming]?: KeyframeTiming[K] | undefined }): KeyframeTiming {
  return { transition: key.transition ?? 'transition', durationSeconds: key.durationSeconds ?? 2, easing: key.easing ?? 'smooth' };
}

export function sceneKeyTiming(transition: CinematicWaypoint['transition']): KeyframeTiming {
  return transition.type === 'cut' ? { transition: 'cut', durationSeconds: 2, easing: 'smooth' } : {
    transition: 'transition', durationSeconds: transition.entireInterval ? 'interval' : transition.durationSeconds, easing: transition.easing ?? 'smooth',
  };
}

/** Adapt the common editing controls without changing the saved sequence format. */
export function changeSceneKeyTiming(previous: CinematicWaypoint['transition'], change: Partial<KeyframeTiming>): CinematicWaypoint['transition'] {
  const next = { ...sceneKeyTiming(previous), ...change };
  if (next.transition === 'cut') return { type: 'cut', ...(previous.timing ? { timing: previous.timing } : {}) };
  return { ...(previous.type === 'smooth' ? previous : {}), type: 'smooth', timing: previous.timing ?? 'arrival',
    durationSeconds: typeof next.durationSeconds === 'number' ? next.durationSeconds : previous.type === 'smooth' ? previous.durationSeconds : 2,
    ...(next.durationSeconds === 'interval' ? { entireInterval: true } : previous.type === 'smooth' && previous.entireInterval !== undefined ? { entireInterval: false } : {}),
    easing: next.easing };
}
